module.exports = __webpack_public_path__ + "img/activity.7f1cf9a9.png";